'use strict';
const angular = require('angular');

export class specifyProxyComponent {
  /*@ngInject*/
  constructor(SettingsService) {
    this.proxyTypes = [];
    SettingsService.getByName({name: "client"}, settings => {
      if (!settings.data.proxy.onlyDefaultProxy) {
        this.proxyTypes.push({
          type: "write-in",
          name: "My Self-Chosen Proxy"
        });
      }
    });

  }

  $onInit () {
    this.config = this.resolve.config;

    this.defaultProxy = this.config.defaultProxy;

    if (this.defaultProxy && this.defaultProxy.enabled && this.defaultProxy.name) {
      this.proxyTypes.unshift({
        type: "default",
        name: "My Community's Default Proxy Holder"
      })
    }

    this.proxies = angular.copy(this.config.proxies);
    this.properties = this.config.properties.map(ppty => {

      let group = "No Proxy Assigned:";

      let o = this.proxies.find(p => p.property == ppty._id);
      if (o && o.proxy.enabled) {
        group = (o.proxy.type == "default") ? "Default Proxy:" : "Self-Chosen Proxy:";
      }

      return {
        id: ppty._id,
        name: "# " + ppty.lotNo + " / " + ( (ppty.address) ? ppty.address.street : "-"),
        group: group
      }
    });

    if (this.properties.length == 1) {
      this.selectedProperty = this.properties[0]._i;
      let o = this.proxies.find(p => p.property == this.selectedProperty);
      this.proxy = (o) ? o.proxy : {};
    }

  };

  updateProxySettings() {
    let o = this.proxies.find(p => p.property == this.selectedProperty);
    this.proxy = (o) ? o.proxy : {};
  }

  ok() {
    this.close({$value: {proxy: this.proxy, propertyId: this.selectedProperty, applyToAllProperties: this.applyToAllProperties}});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.specifyProxy', [])
  .component('specifyProxy', {
    template: require('./specify-proxy.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: specifyProxyComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/specify-proxy/specify-proxy.component.js